<!--
@Create By Tim For 19/09/08
@视频播放组件
-->
<template>
  <div class="VideoPlayer">
    <el-dialog :visible.sync="dialogVisible" title="播放" width="50%" :before-close="closeVideo">
      <video-player class="vjs-custom-skin" ref="videoPlayer" :options="playerOptions" :playsinline="true">
      </video-player>
    </el-dialog>
  </div>
</template>

<script>
import { videoPlayer } from 'vue-video-player'
export default {
  name: 'VideoPlayer',
  props: ['videoURL'],
  data() {
    return {
      dialogVisible: false,
      playerOptions: {
        height: '500',
        // 自动播放
        autoplay: true,
        // 静音
        muted: false,
        preload: 'auto',
        language: 'zh-CN',
        live: false,
        // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        fluid: true,
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            type: 'application/x-mpegURL',
            src: this.videoURL,
          },
        ],
        notSupportedMessage: '此视频暂无法播放，请稍后再试',
        // 封面地址
        poster: '',
        controlBar: {
          timeDivider: true,
          durationDisplay: false,
          remainingTimeDisplay: false,
          //全屏按钮
          fullscreenToggle: true,
          progressControl: true,
        },
      },
    }
  },

  components: {
    videoPlayer,
  },

  computed: {
    player() {
      return this.$refs.videoPlayer.player
    },
  },

  created() {},

  mounted() {},

  methods: {
    // 关闭视频弹窗前先调用父组件的清除视频URL方法然后再关闭弹窗
    closeVideo() {
      this.$emit('clearURL')
      this.dialogVisible = false
    },

    // 打开视频播放弹窗
    openVideoDialog() {
      this.dialogVisible = true
    },
  },
}
</script>

<style scoped>
.VideoPlayer {
}
</style>



// WEBPACK FOOTER //
// src/components/VideoPlayer/VideoPlayer.vue